import React from 'react';
import { RecipesList, SEOCategory } from '../components';

export default function Bakery() {
  const recipes = [
    {
      activeClassName: 'achma',
      title: 'Ачма с томатным соусом',
      ref: '/achma-b',
      bgImage: '/achma.jpg'
    },
    {
      activeClassName: 'envelopetuna',
      title: 'Хрустящие конвертики из слоеного теста с салатом из тунца и соусом «Сальса»',
      ref: '/envelopetuna-b',
      bgImage: '/envelopetuna.jpg'
    },
    {
      activeClassName: 'openpie',
      title: 'Открытый пирог из слоеного теста с картофелем и копчеными колбасками',
      ref: '/openpie',
      bgImage: '/openpie.jpg'
    },
    {
      activeClassName: 'chockmed',
      title: 'Шоколадный медовик',
      ref: '/chockmed',
      bgImage: '/chockmed.jpg'
    },
    {
      activeClassName: 'cheesecake',
      title: 'Чизкейк «Нью-Йорк»',
      ref: '/cheesecake',
      bgImage: '/cheesecake.jpg'
    },
    {
      activeClassName: 'khachapuri',
      title: 'Хачапури по-аджарски',
      ref: '/khachapuri',
      bgImage: '/khachapuri.jpg'
    },
    {
      activeClassName: 'cotcheesecake',
      title: 'Творожный чизкейк с вишней без выпечки',
      ref: '/cotcheesecake',
      bgImage: '/cotcheesecake.png'
    },
    {
      activeClassName: 'caramelmed',
      title: 'Карамельный медовик',
      ref: '/caramelmed',
      bgImage: '/caramelmed.jpg'
    },
    {
      activeClassName: 'grechtort',
      title: 'Гречневый торт с черносливом, грушей и сметанным кремом',
      ref: '/grechtort',
      bgImage: '/grechtort.jpg'
    },
  ];

  return(
    <>
      <SEOCategory category='Выпечка' thisImage='bakery.jpg' thisUrl='bakery' />
      <RecipesList recipes={recipes} title='Выпечка' page='bakery' />
    </>
  )
}
